module.exports = __webpack_public_path__ + "static/pillar-of-hope-0560674f2fb4d3aad01f6b58f636ea8a.jpg";